$(document).ready(function () {
  function variantSwatch () {
    const productId = Number($(this).attr('data-product-id'))
    const variantId = Number($(this).attr('data-variant-id'))
    const variantPrice = $(this).attr('data-price')
    const variantComparePrice = $(this).attr('data-compare-price')
    const variantSelector = $(`select[data-product-id='${productId}']`)
    const variantOption = variantSelector.find('option')

    $(`.product-info__form-price[data-product-id='${productId}']`).text(`${variantPrice}`)
    $(`.product-info__form-compare-price[data-product-id='${productId}']`).text(`${variantComparePrice}`)

    variantOption.each(function () {
      if (Number($(this).val()) === variantId) {
        $(this).attr('selected', 'selected')
        variantSelector.attr('value',`${variantId}`)
      } else {
        $(this).removeAttr('selected')
      }
    })
  }
  $('.product-info__form-radio').on('change', variantSwatch)
})